import React from "react";
import { MdStar, MdStarHalf, MdStarBorder } from "react-icons/md";

export interface StarsProps {
  numberOfStars: number;
}

export const Stars = ({ numberOfStars }: StarsProps) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    if (i <= Math.floor(numberOfStars)) {
      // Full star for each integer value up to numberOfStars
      stars.push(<MdStar className="w-4 h-4 text-amber-500" key={i} />);
    } else if (i - 1 < numberOfStars && i > numberOfStars) {
      // Check if there should be a half star
      // This condition is true when the current index is within the range of numberOfStars and the next integer.
      const fractionalPart = numberOfStars - Math.floor(numberOfStars);
      if (fractionalPart >= 0.25 && fractionalPart < 0.75) {
        // Display half star if the fractional part is between 0.25 and 0.75
        stars.push(<MdStarHalf className="w-4 h-4 text-amber-500" key={i} />);
      } else if (fractionalPart >= 0.75) {
        // Consider it as a full star if the fractional part is equal to or more than 0.75
        stars.push(<MdStar className="w-4 h-4 text-amber-500" key={i} />);
      } else {
        // Display empty star if the fractional part is less than 0.25
        stars.push(
          <MdStarBorder
            className="w-4 h-4 text-slate-300 dark:text-slate-600"
            key={i}
          />
        );
      }
    } else {
      // Empty star for the rest
      stars.push(
        <MdStarBorder
          className="w-4 h-4 text-slate-300 dark:text-slate-600"
          key={i}
        />
      );
    }
  }

  return <div className="flex space-x-1">{stars}</div>;
};
